import { Grid, Paper } from "@mui/material"
import { ReportTabs } from "components/Common/ReportTabs"
import { Title } from "components/Common/Title"
import { GrowthChart } from "components/Report/GrowthChart"
import { useEffect, useState } from "react"
import organizationService from "services/organizationService"
import { hiabColors } from "theme"
import type { IAllOrganizationsGrowthReport } from "types/reportTypes"

export function GrowthReport() {
  const [report, setReport] = useState<IAllOrganizationsGrowthReport | undefined>(undefined)

  useEffect(() => {
    organizationService
      .getAllOrganizationsGrowthReport()
      .then((data) => {
        setReport(data)
      })
      .catch((err) => {
        console.log(err)
      })
  }, [])

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <ReportTabs activeTab={1} />
      </Grid>

      <Grid item xs={12}>
        <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
          <Title>USERS (TRAILING 12 MONTHS)</Title>
          {report !== undefined && <GrowthChart months={report.months} data={report.users} color={hiabColors.bluePrimary} />}
        </Paper>
      </Grid>

      <Grid item xs={12}>
        <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
          <Title>LICENSES (TRAILING 12 MONTHS)</Title>
          {report !== undefined && <GrowthChart months={report.months} data={report.licenses} color={hiabColors.greyPrimary} />}
        </Paper>
      </Grid>

      <Grid item xs={12} sx={{ mb: 6 }}>
        <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
          <Title>TRAINING REPORTS (TRAILING 12 MONTHS)</Title>
          {report !== undefined && <GrowthChart months={report.months} data={report.trainingReports} color={hiabColors.redPrimary} />}
        </Paper>
      </Grid>
    </Grid>
  )
}
